import { pathOr } from 'ramda'

import { isString } from '@fmpedia/helpers'
import { isHrefValid } from '@fmpedia/validators'

import {
  addEndingSlash,
  checkIfLinkHasProtocol,
  guid,
  parseUrl,
  removeEndingSlashes,
  removeStartingSlash
} from '../utils/helpers/index'

export {
  guid,
  parseUrl,
  addEndingSlash,
  removeEndingSlashes,
  removeStartingSlash,
  checkIfLinkHasProtocol
}

/* @fmpedia/helpers */
export { isHrefValid, isString }

export function getUrlHost(url) {
  if (!url) return null

  try {
    return new URL(url).host
  } catch (err) {
    return null
  }
}

function testHrefValidator() {
  const hrefValidationTests = [
    { href: 'https://google.com', isValid: true },
    { href: 'http://google.com', isValid: true },
    { href: 'ftp://google.com', isValid: true },
    { href: '//google.com', isValid: true },
    { href: '/all-news', isValid: true },
    { href: '#', isValid: true },
    { href: '#anchor', isValid: true },
    { href: 'mailto:some@email.com', isValid: true },
    { href: 'mailto:some@gibberish', isValid: false },
    { href: 'mailto:', isValid: false },
    { href: 'discord://some-data', isValid: true },
    { href: 'all-news', isValid: false },
    { href: 'google.com', isValid: false },
    { href: 'Minister: how are you', isValid: false },
    { href: '', isValid: false }
  ]
  const results = hrefValidationTests.reduce((acc, { href, isValid }) => {
    const isValidJsLib = isHrefValid(href)
    return {
      ...acc,
      [href]: {
        isValidExpected: isValid,
        isValidActual: isValidJsLib,
        Passed: isValidJsLib === isValid
      }
    }
  }, {})
  if (Object.values(results).some(({ Passed }) => Passed === false)) {
    console.log('== server/helper.js - isHrefValid() helper test(s) failed ==')
    console.table(results)
  }
}

if (process.env.NODE_ENV === 'development') {
  testHrefValidator()
}

export function getBackendErrorCode(err) {
  return (
    pathOr(null, ['response', 'data', 'ErrorCode'], err) ||
    pathOr(null, ['response', 'data', 'Code'], err)
  )
}

export function getBackendErrorEvidence(err) {
  return pathOr(null, ['response', 'data', 'Evidence'], err)
}
